const timezones = [
    {
        "id": "Pacific/Midway",
        "name": "(UTC -11:00) Pacific/Midway"
    },
    {
        "id": "Pacific/Niue",
        "name": "(UTC -11:00) Pacific/Niue"
    },
    {
        "id": "Pacific/Pago_Pago",
        "name": "(UTC -11:00) Pacific/Pago_Pago"
    },
    {
        "id": "Pacific/Honolulu",
        "name": "(UTC -10:00) Pacific/Honolulu"
    },
    {
        "id": "Pacific/Rarotonga",
        "name": "(UTC -10:00) Pacific/Rarotonga"
    },
    {
        "id": "Pacific/Tahiti",
        "name": "(UTC -10:00) Pacific/Tahiti"
    },
    {
        "id": "Pacific/Marquesas",
        "name": "(UTC -09:30) Pacific/Marquesas"
    },
    {
        "id": "America/Adak",
        "name": "(UTC -09:00) America/Adak"
    },
    {
        "id": "Pacific/Gambier",
        "name": "(UTC -09:00) Pacific/Gambier"
    },
    {
        "id": "America/Anchorage",
        "name": "(UTC -08:00) America/Anchorage"
    },
    {
        "id": "America/Juneau",
        "name": "(UTC -08:00) America/Juneau"
    },
    {
        "id": "America/Metlakatla",
        "name": "(UTC -08:00) America/Metlakatla"
    },
    {
        "id": "America/Nome",
        "name": "(UTC -08:00) America/Nome"
    },
    {
        "id": "America/Sitka",
        "name": "(UTC -08:00) America/Sitka"
    },
    {
        "id": "America/Yakutat",
        "name": "(UTC -08:00) America/Yakutat"
    },
    {
        "id": "Pacific/Pitcairn",
        "name": "(UTC -08:00) Pacific/Pitcairn"
    },
    {
        "id": "America/Chihuahua",
        "name": "(UTC -07:00) America/Chihuahua"
    },
    {
        "id": "America/Creston",
        "name": "(UTC -07:00) America/Creston"
    },
    {
        "id": "America/Dawson",
        "name": "(UTC -07:00) America/Dawson"
    },
    {
        "id": "America/Dawson_Creek",
        "name": "(UTC -07:00) America/Dawson_Creek"
    },
    {
        "id": "America/Fort_Nelson",
        "name": "(UTC -07:00) America/Fort_Nelson"
    },
    {
        "id": "America/Hermosillo",
        "name": "(UTC -07:00) America/Hermosillo"
    },
    {
        "id": "America/Los_Angeles",
        "name": "(UTC -07:00) America/Los_Angeles"
    },
    {
        "id": "America/Mazatlan",
        "name": "(UTC -07:00) America/Mazatlan"
    },
    {
        "id": "America/Phoenix",
        "name": "(UTC -07:00) America/Phoenix"
    },
    {
        "id": "America/Tijuana",
        "name": "(UTC -07:00) America/Tijuana"
    },
    {
        "id": "America/Vancouver",
        "name": "(UTC -07:00) America/Vancouver"
    },
    {
        "id": "America/Whitehorse",
        "name": "(UTC -07:00) America/Whitehorse"
    },
    {
        "id": "America/Bahia_Banderas",
        "name": "(UTC -06:00) America/Bahia_Banderas"
    },
    {
        "id": "America/Belize",
        "name": "(UTC -06:00) America/Belize"
    },
    {
        "id": "America/Boise",
        "name": "(UTC -06:00) America/Boise"
    },
    {
        "id": "America/Cambridge_Bay",
        "name": "(UTC -06:00) America/Cambridge_Bay"
    },
    {
        "id": "America/Costa_Rica",
        "name": "(UTC -06:00) America/Costa_Rica"
    },
    {
        "id": "America/Denver",
        "name": "(UTC -06:00) America/Denver"
    },
    {
        "id": "America/Edmonton",
        "name": "(UTC -06:00) America/Edmonton"
    },
    {
        "id": "America/El_Salvador",
        "name": "(UTC -06:00) America/El_Salvador"
    },
    {
        "id": "America/Guatemala",
        "name": "(UTC -06:00) America/Guatemala"
    },
    {
        "id": "America/Inuvik",
        "name": "(UTC -06:00) America/Inuvik"
    },
    {
        "id": "America/Managua",
        "name": "(UTC -06:00) America/Managua"
    },
    {
        "id": "America/Merida",
        "name": "(UTC -06:00) America/Merida"
    },
    {
        "id": "America/Mexico_City",
        "name": "(UTC -06:00) America/Mexico_City"
    },
    {
        "id": "America/Monterrey",
        "name": "(UTC -06:00) America/Monterrey"
    },
    {
        "id": "America/Ojinaga",
        "name": "(UTC -06:00) America/Ojinaga"
    },
    {
        "id": "America/Regina",
        "name": "(UTC -06:00) America/Regina"
    },
    {
        "id": "America/Swift_Current",
        "name": "(UTC -06:00) America/Swift_Current"
    },
    {
        "id": "America/Tegucigalpa",
        "name": "(UTC -06:00) America/Tegucigalpa"
    },
    {
        "id": "America/Yellowknife",
        "name": "(UTC -06:00) America/Yellowknife"
    },
    {
        "id": "Pacific/Galapagos",
        "name": "(UTC -06:00) Pacific/Galapagos"
    },
    {
        "id": "America/Atikokan",
        "name": "(UTC -05:00) America/Atikokan"
    },
    {
        "id": "America/Bogota",
        "name": "(UTC -05:00) America/Bogota"
    },
    {
        "id": "America/Cancun",
        "name": "(UTC -05:00) America/Cancun"
    },
    {
        "id": "America/Cayman",
        "name": "(UTC -05:00) America/Cayman"
    },
    {
        "id": "America/Chicago",
        "name": "(UTC -05:00) America/Chicago"
    },
    {
        "id": "America/Eirunepe",
        "name": "(UTC -05:00) America/Eirunepe"
    },
    {
        "id": "America/Guayaquil",
        "name": "(UTC -05:00) America/Guayaquil"
    },
    {
        "id": "America/Indiana/Knox",
        "name": "(UTC -05:00) America/Indiana/Knox"
    },
    {
        "id": "America/Indiana/Tell_City",
        "name": "(UTC -05:00) America/Indiana/Tell_City"
    },
    {
        "id": "America/Jamaica",
        "name": "(UTC -05:00) America/Jamaica"
    },
    {
        "id": "America/Lima",
        "name": "(UTC -05:00) America/Lima"
    },
    {
        "id": "America/Matamoros",
        "name": "(UTC -05:00) America/Matamoros"
    },
    {
        "id": "America/Menominee",
        "name": "(UTC -05:00) America/Menominee"
    },
    {
        "id": "America/North_Dakota/Beulah",
        "name": "(UTC -05:00) America/North_Dakota/Beulah"
    },
    {
        "id": "America/North_Dakota/Center",
        "name": "(UTC -05:00) America/North_Dakota/Center"
    },
    {
        "id": "America/North_Dakota/New_Salem",
        "name": "(UTC -05:00) America/North_Dakota/New_Salem"
    },
    {
        "id": "America/Panama",
        "name": "(UTC -05:00) America/Panama"
    },
    {
        "id": "America/Rainy_River",
        "name": "(UTC -05:00) America/Rainy_River"
    },
    {
        "id": "America/Rankin_Inlet",
        "name": "(UTC -05:00) America/Rankin_Inlet"
    },
    {
        "id": "America/Resolute",
        "name": "(UTC -05:00) America/Resolute"
    },
    {
        "id": "America/Rio_Branco",
        "name": "(UTC -05:00) America/Rio_Branco"
    },
    {
        "id": "America/Winnipeg",
        "name": "(UTC -05:00) America/Winnipeg"
    },
    {
        "id": "Pacific/Easter",
        "name": "(UTC -05:00) Pacific/Easter"
    },
    {
        "id": "America/Anguilla",
        "name": "(UTC -04:00) America/Anguilla"
    },
    {
        "id": "America/Antigua",
        "name": "(UTC -04:00) America/Antigua"
    },
    {
        "id": "America/Aruba",
        "name": "(UTC -04:00) America/Aruba"
    },
    {
        "id": "America/Barbados",
        "name": "(UTC -04:00) America/Barbados"
    },
    {
        "id": "America/Blanc-Sablon",
        "name": "(UTC -04:00) America/Blanc-Sablon"
    },
    {
        "id": "America/Boa_Vista",
        "name": "(UTC -04:00) America/Boa_Vista"
    },
    {
        "id": "America/Campo_Grande",
        "name": "(UTC -04:00) America/Campo_Grande"
    },
    {
        "id": "America/Caracas",
        "name": "(UTC -04:00) America/Caracas"
    },
    {
        "id": "America/Cuiaba",
        "name": "(UTC -04:00) America/Cuiaba"
    },
    {
        "id": "America/Curacao",
        "name": "(UTC -04:00) America/Curacao"
    },
    {
        "id": "America/Detroit",
        "name": "(UTC -04:00) America/Detroit"
    },
    {
        "id": "America/Dominica",
        "name": "(UTC -04:00) America/Dominica"
    },
    {
        "id": "America/Grand_Turk",
        "name": "(UTC -04:00) America/Grand_Turk"
    },
    {
        "id": "America/Grenada",
        "name": "(UTC -04:00) America/Grenada"
    },
    {
        "id": "America/Guadeloupe",
        "name": "(UTC -04:00) America/Guadeloupe"
    },
    {
        "id": "America/Guyana",
        "name": "(UTC -04:00) America/Guyana"
    },
    {
        "id": "America/Havana",
        "name": "(UTC -04:00) America/Havana"
    },
    {
        "id": "America/Indiana/Indianapolis",
        "name": "(UTC -04:00) America/Indiana/Indianapolis"
    },
    {
        "id": "America/Indiana/Marengo",
        "name": "(UTC -04:00) America/Indiana/Marengo"
    },
    {
        "id": "America/Indiana/Petersburg",
        "name": "(UTC -04:00) America/Indiana/Petersburg"
    },
    {
        "id": "America/Indiana/Vevay",
        "name": "(UTC -04:00) America/Indiana/Vevay"
    },
    {
        "id": "America/Indiana/Vincennes",
        "name": "(UTC -04:00) America/Indiana/Vincennes"
    },
    {
        "id": "America/Indiana/Winamac",
        "name": "(UTC -04:00) America/Indiana/Winamac"
    },
    {
        "id": "America/Iqaluit",
        "name": "(UTC -04:00) America/Iqaluit"
    },
    {
        "id": "America/Kentucky/Louisville",
        "name": "(UTC -04:00) America/Kentucky/Louisville"
    },
    {
        "id": "America/Kentucky/Monticello",
        "name": "(UTC -04:00) America/Kentucky/Monticello"
    },
    {
        "id": "America/Kralendijk",
        "name": "(UTC -04:00) America/Kralendijk"
    },
    {
        "id": "America/La_Paz",
        "name": "(UTC -04:00) America/La_Paz"
    },
    {
        "id": "America/Lower_Princes",
        "name": "(UTC -04:00) America/Lower_Princes"
    },
    {
        "id": "America/Manaus",
        "name": "(UTC -04:00) America/Manaus"
    },
    {
        "id": "America/Marigot",
        "name": "(UTC -04:00) America/Marigot"
    },
    {
        "id": "America/Martinique",
        "name": "(UTC -04:00) America/Martinique"
    },
    {
        "id": "America/Montserrat",
        "name": "(UTC -04:00) America/Montserrat"
    },
    {
        "id": "America/Nassau",
        "name": "(UTC -04:00) America/Nassau"
    },
    {
        "id": "America/New_York",
        "name": "(UTC -04:00) America/New_York"
    },
    {
        "id": "America/Nipigon",
        "name": "(UTC -04:00) America/Nipigon"
    },
    {
        "id": "America/Pangnirtung",
        "name": "(UTC -04:00) America/Pangnirtung"
    },
    {
        "id": "America/Port-au-Prince",
        "name": "(UTC -04:00) America/Port-au-Prince"
    },
    {
        "id": "America/Port_of_Spain",
        "name": "(UTC -04:00) America/Port_of_Spain"
    },
    {
        "id": "America/Porto_Velho",
        "name": "(UTC -04:00) America/Porto_Velho"
    },
    {
        "id": "America/Puerto_Rico",
        "name": "(UTC -04:00) America/Puerto_Rico"
    },
    {
        "id": "America/Santo_Domingo",
        "name": "(UTC -04:00) America/Santo_Domingo"
    },
    {
        "id": "America/St_Barthelemy",
        "name": "(UTC -04:00) America/St_Barthelemy"
    },
    {
        "id": "America/St_Kitts",
        "name": "(UTC -04:00) America/St_Kitts"
    },
    {
        "id": "America/St_Lucia",
        "name": "(UTC -04:00) America/St_Lucia"
    },
    {
        "id": "America/St_Thomas",
        "name": "(UTC -04:00) America/St_Thomas"
    },
    {
        "id": "America/St_Vincent",
        "name": "(UTC -04:00) America/St_Vincent"
    },
    {
        "id": "America/Thunder_Bay",
        "name": "(UTC -04:00) America/Thunder_Bay"
    },
    {
        "id": "America/Toronto",
        "name": "(UTC -04:00) America/Toronto"
    },
    {
        "id": "America/Tortola",
        "name": "(UTC -04:00) America/Tortola"
    },
    {
        "id": "America/Araguaina",
        "name": "(UTC -03:00) America/Araguaina"
    },
    {
        "id": "America/Argentina/Buenos_Aires",
        "name": "(UTC -03:00) America/Argentina/Buenos_Aires"
    },
    {
        "id": "America/Argentina/Catamarca",
        "name": "(UTC -03:00) America/Argentina/Catamarca"
    },
    {
        "id": "America/Argentina/Cordoba",
        "name": "(UTC -03:00) America/Argentina/Cordoba"
    },
    {
        "id": "America/Argentina/Jujuy",
        "name": "(UTC -03:00) America/Argentina/Jujuy"
    },
    {
        "id": "America/Argentina/La_Rioja",
        "name": "(UTC -03:00) America/Argentina/La_Rioja"
    },
    {
        "id": "America/Argentina/Mendoza",
        "name": "(UTC -03:00) America/Argentina/Mendoza"
    },
    {
        "id": "America/Argentina/Rio_Gallegos",
        "name": "(UTC -03:00) America/Argentina/Rio_Gallegos"
    },
    {
        "id": "America/Argentina/Salta",
        "name": "(UTC -03:00) America/Argentina/Salta"
    },
    {
        "id": "America/Argentina/San_Juan",
        "name": "(UTC -03:00) America/Argentina/San_Juan"
    },
    {
        "id": "America/Argentina/San_Luis",
        "name": "(UTC -03:00) America/Argentina/San_Luis"
    },
    {
        "id": "America/Argentina/Tucuman",
        "name": "(UTC -03:00) America/Argentina/Tucuman"
    },
    {
        "id": "America/Argentina/Ushuaia",
        "name": "(UTC -03:00) America/Argentina/Ushuaia"
    },
    {
        "id": "America/Asuncion",
        "name": "(UTC -03:00) America/Asuncion"
    },
    {
        "id": "America/Bahia",
        "name": "(UTC -03:00) America/Bahia"
    },
    {
        "id": "America/Belem",
        "name": "(UTC -03:00) America/Belem"
    },
    {
        "id": "America/Cayenne",
        "name": "(UTC -03:00) America/Cayenne"
    },
    {
        "id": "America/Fortaleza",
        "name": "(UTC -03:00) America/Fortaleza"
    },
    {
        "id": "America/Glace_Bay",
        "name": "(UTC -03:00) America/Glace_Bay"
    },
    {
        "id": "America/Goose_Bay",
        "name": "(UTC -03:00) America/Goose_Bay"
    },
    {
        "id": "America/Halifax",
        "name": "(UTC -03:00) America/Halifax"
    },
    {
        "id": "America/Maceio",
        "name": "(UTC -03:00) America/Maceio"
    },
    {
        "id": "America/Moncton",
        "name": "(UTC -03:00) America/Moncton"
    },
    {
        "id": "America/Montevideo",
        "name": "(UTC -03:00) America/Montevideo"
    },
    {
        "id": "America/Nuuk",
        "name": "(UTC -03:00) America/Nuuk"
    },
    {
        "id": "America/Paramaribo",
        "name": "(UTC -03:00) America/Paramaribo"
    },
    {
        "id": "America/Punta_Arenas",
        "name": "(UTC -03:00) America/Punta_Arenas"
    },
    {
        "id": "America/Recife",
        "name": "(UTC -03:00) America/Recife"
    },
    {
        "id": "America/Santarem",
        "name": "(UTC -03:00) America/Santarem"
    },
    {
        "id": "America/Santiago",
        "name": "(UTC -03:00) America/Santiago"
    },
    {
        "id": "America/Sao_Paulo",
        "name": "(UTC -03:00) America/Sao_Paulo"
    },
    {
        "id": "America/Thule",
        "name": "(UTC -03:00) America/Thule"
    },
    {
        "id": "Antarctica/Palmer",
        "name": "(UTC -03:00) Antarctica/Palmer"
    },
    {
        "id": "Antarctica/Rothera",
        "name": "(UTC -03:00) Antarctica/Rothera"
    },
    {
        "id": "Atlantic/Bermuda",
        "name": "(UTC -03:00) Atlantic/Bermuda"
    },
    {
        "id": "Atlantic/Stanley",
        "name": "(UTC -03:00) Atlantic/Stanley"
    },
    {
        "id": "America/St_Johns",
        "name": "(UTC -02:30) America/St_Johns"
    },
    {
        "id": "America/Miquelon",
        "name": "(UTC -02:00) America/Miquelon"
    },
    {
        "id": "America/Noronha",
        "name": "(UTC -02:00) America/Noronha"
    },
    {
        "id": "Atlantic/South_Georgia",
        "name": "(UTC -02:00) Atlantic/South_Georgia"
    },
    {
        "id": "America/Scoresbysund",
        "name": "(UTC -01:00) America/Scoresbysund"
    },
    {
        "id": "Atlantic/Azores",
        "name": "(UTC -01:00) Atlantic/Azores"
    },
    {
        "id": "Atlantic/Cape_Verde",
        "name": "(UTC -01:00) Atlantic/Cape_Verde"
    },
    {
        "id": "Africa/Abidjan",
        "name": "(UTC -00:00) Africa/Abidjan"
    },
    {
        "id": "Africa/Accra",
        "name": "(UTC -00:00) Africa/Accra"
    },
    {
        "id": "Africa/Bamako",
        "name": "(UTC -00:00) Africa/Bamako"
    },
    {
        "id": "Africa/Banjul",
        "name": "(UTC -00:00) Africa/Banjul"
    },
    {
        "id": "Africa/Bissau",
        "name": "(UTC -00:00) Africa/Bissau"
    },
    {
        "id": "Africa/Conakry",
        "name": "(UTC -00:00) Africa/Conakry"
    },
    {
        "id": "Africa/Dakar",
        "name": "(UTC -00:00) Africa/Dakar"
    },
    {
        "id": "Africa/Freetown",
        "name": "(UTC -00:00) Africa/Freetown"
    },
    {
        "id": "Africa/Lome",
        "name": "(UTC -00:00) Africa/Lome"
    },
    {
        "id": "Africa/Monrovia",
        "name": "(UTC -00:00) Africa/Monrovia"
    },
    {
        "id": "Africa/Nouakchott",
        "name": "(UTC -00:00) Africa/Nouakchott"
    },
    {
        "id": "Africa/Ouagadougou",
        "name": "(UTC -00:00) Africa/Ouagadougou"
    },
    {
        "id": "Africa/Sao_Tome",
        "name": "(UTC -00:00) Africa/Sao_Tome"
    },
    {
        "id": "America/Danmarkshavn",
        "name": "(UTC -00:00) America/Danmarkshavn"
    },
    {
        "id": "Antarctica/Troll",
        "name": "(UTC -00:00) Antarctica/Troll"
    },
    {
        "id": "Atlantic/Canary",
        "name": "(UTC -00:00) Atlantic/Canary"
    },
    {
        "id": "Atlantic/Faroe",
        "name": "(UTC -00:00) Atlantic/Faroe"
    },
    {
        "id": "Atlantic/Madeira",
        "name": "(UTC -00:00) Atlantic/Madeira"
    },
    {
        "id": "Atlantic/Reykjavik",
        "name": "(UTC -00:00) Atlantic/Reykjavik"
    },
    {
        "id": "Atlantic/St_Helena",
        "name": "(UTC -00:00) Atlantic/St_Helena"
    },
    {
        "id": "Europe/Dublin",
        "name": "(UTC -00:00) Europe/Dublin"
    },
    {
        "id": "Europe/Guernsey",
        "name": "(UTC -00:00) Europe/Guernsey"
    },
    {
        "id": "Europe/Isle_of_Man",
        "name": "(UTC -00:00) Europe/Isle_of_Man"
    },
    {
        "id": "Europe/Jersey",
        "name": "(UTC -00:00) Europe/Jersey"
    },
    {
        "id": "Europe/Lisbon",
        "name": "(UTC -00:00) Europe/Lisbon"
    },
    {
        "id": "Europe/London",
        "name": "(UTC -00:00) Europe/London"
    },
    {
        "id": "UTC",
        "name": "(UTC -00:00) UTC"
    },
    {
        "id": "Africa/Algiers",
        "name": "(UTC +01:00) Africa/Algiers"
    },
    {
        "id": "Africa/Bangui",
        "name": "(UTC +01:00) Africa/Bangui"
    },
    {
        "id": "Africa/Brazzaville",
        "name": "(UTC +01:00) Africa/Brazzaville"
    },
    {
        "id": "Africa/Casablanca",
        "name": "(UTC +01:00) Africa/Casablanca"
    },
    {
        "id": "Africa/Ceuta",
        "name": "(UTC +01:00) Africa/Ceuta"
    },
    {
        "id": "Africa/Douala",
        "name": "(UTC +01:00) Africa/Douala"
    },
    {
        "id": "Africa/El_Aaiun",
        "name": "(UTC +01:00) Africa/El_Aaiun"
    },
    {
        "id": "Africa/Kinshasa",
        "name": "(UTC +01:00) Africa/Kinshasa"
    },
    {
        "id": "Africa/Lagos",
        "name": "(UTC +01:00) Africa/Lagos"
    },
    {
        "id": "Africa/Libreville",
        "name": "(UTC +01:00) Africa/Libreville"
    },
    {
        "id": "Africa/Luanda",
        "name": "(UTC +01:00) Africa/Luanda"
    },
    {
        "id": "Africa/Malabo",
        "name": "(UTC +01:00) Africa/Malabo"
    },
    {
        "id": "Africa/Ndjamena",
        "name": "(UTC +01:00) Africa/Ndjamena"
    },
    {
        "id": "Africa/Niamey",
        "name": "(UTC +01:00) Africa/Niamey"
    },
    {
        "id": "Africa/Porto-Novo",
        "name": "(UTC +01:00) Africa/Porto-Novo"
    },
    {
        "id": "Africa/Tunis",
        "name": "(UTC +01:00) Africa/Tunis"
    },
    {
        "id": "Arctic/Longyearbyen",
        "name": "(UTC +01:00) Arctic/Longyearbyen"
    },
    {
        "id": "Europe/Amsterdam",
        "name": "(UTC +01:00) Europe/Amsterdam"
    },
    {
        "id": "Europe/Andorra",
        "name": "(UTC +01:00) Europe/Andorra"
    },
    {
        "id": "Europe/Belgrade",
        "name": "(UTC +01:00) Europe/Belgrade"
    },
    {
        "id": "Europe/Berlin",
        "name": "(UTC +01:00) Europe/Berlin"
    },
    {
        "id": "Europe/Bratislava",
        "name": "(UTC +01:00) Europe/Bratislava"
    },
    {
        "id": "Europe/Brussels",
        "name": "(UTC +01:00) Europe/Brussels"
    },
    {
        "id": "Europe/Budapest",
        "name": "(UTC +01:00) Europe/Budapest"
    },
    {
        "id": "Europe/Busingen",
        "name": "(UTC +01:00) Europe/Busingen"
    },
    {
        "id": "Europe/Copenhagen",
        "name": "(UTC +01:00) Europe/Copenhagen"
    },
    {
        "id": "Europe/Gibraltar",
        "name": "(UTC +01:00) Europe/Gibraltar"
    },
    {
        "id": "Europe/Ljubljana",
        "name": "(UTC +01:00) Europe/Ljubljana"
    },
    {
        "id": "Europe/Luxembourg",
        "name": "(UTC +01:00) Europe/Luxembourg"
    },
    {
        "id": "Europe/Madrid",
        "name": "(UTC +01:00) Europe/Madrid"
    },
    {
        "id": "Europe/Malta",
        "name": "(UTC +01:00) Europe/Malta"
    },
    {
        "id": "Europe/Monaco",
        "name": "(UTC +01:00) Europe/Monaco"
    },
    {
        "id": "Europe/Oslo",
        "name": "(UTC +01:00) Europe/Oslo"
    },
    {
        "id": "Europe/Paris",
        "name": "(UTC +01:00) Europe/Paris"
    },
    {
        "id": "Europe/Podgorica",
        "name": "(UTC +01:00) Europe/Podgorica"
    },
    {
        "id": "Europe/Prague",
        "name": "(UTC +01:00) Europe/Prague"
    },
    {
        "id": "Europe/Rome",
        "name": "(UTC +01:00) Europe/Rome"
    },
    {
        "id": "Europe/San_Marino",
        "name": "(UTC +01:00) Europe/San_Marino"
    },
    {
        "id": "Europe/Sarajevo",
        "name": "(UTC +01:00) Europe/Sarajevo"
    },
    {
        "id": "Europe/Skopje",
        "name": "(UTC +01:00) Europe/Skopje"
    },
    {
        "id": "Europe/Stockholm",
        "name": "(UTC +01:00) Europe/Stockholm"
    },
    {
        "id": "Europe/Tirane",
        "name": "(UTC +01:00) Europe/Tirane"
    },
    {
        "id": "Europe/Vaduz",
        "name": "(UTC +01:00) Europe/Vaduz"
    },
    {
        "id": "Europe/Vatican",
        "name": "(UTC +01:00) Europe/Vatican"
    },
    {
        "id": "Europe/Vienna",
        "name": "(UTC +01:00) Europe/Vienna"
    },
    {
        "id": "Europe/Warsaw",
        "name": "(UTC +01:00) Europe/Warsaw"
    },
    {
        "id": "Europe/Zagreb",
        "name": "(UTC +01:00) Europe/Zagreb"
    },
    {
        "id": "Europe/Zurich",
        "name": "(UTC +01:00) Europe/Zurich"
    },
    {
        "id": "Africa/Blantyre",
        "name": "(UTC +02:00) Africa/Blantyre"
    },
    {
        "id": "Africa/Bujumbura",
        "name": "(UTC +02:00) Africa/Bujumbura"
    },
    {
        "id": "Africa/Cairo",
        "name": "(UTC +02:00) Africa/Cairo"
    },
    {
        "id": "Africa/Gaborone",
        "name": "(UTC +02:00) Africa/Gaborone"
    },
    {
        "id": "Africa/Harare",
        "name": "(UTC +02:00) Africa/Harare"
    },
    {
        "id": "Africa/Johannesburg",
        "name": "(UTC +02:00) Africa/Johannesburg"
    },
    {
        "id": "Africa/Juba",
        "name": "(UTC +02:00) Africa/Juba"
    },
    {
        "id": "Africa/Khartoum",
        "name": "(UTC +02:00) Africa/Khartoum"
    },
    {
        "id": "Africa/Kigali",
        "name": "(UTC +02:00) Africa/Kigali"
    },
    {
        "id": "Africa/Lubumbashi",
        "name": "(UTC +02:00) Africa/Lubumbashi"
    },
    {
        "id": "Africa/Lusaka",
        "name": "(UTC +02:00) Africa/Lusaka"
    },
    {
        "id": "Africa/Maputo",
        "name": "(UTC +02:00) Africa/Maputo"
    },
    {
        "id": "Africa/Maseru",
        "name": "(UTC +02:00) Africa/Maseru"
    },
    {
        "id": "Africa/Mbabane",
        "name": "(UTC +02:00) Africa/Mbabane"
    },
    {
        "id": "Africa/Tripoli",
        "name": "(UTC +02:00) Africa/Tripoli"
    },
    {
        "id": "Africa/Windhoek",
        "name": "(UTC +02:00) Africa/Windhoek"
    },
    {
        "id": "Asia/Amman",
        "name": "(UTC +02:00) Asia/Amman"
    },
    {
        "id": "Asia/Beirut",
        "name": "(UTC +02:00) Asia/Beirut"
    },
    {
        "id": "Asia/Damascus",
        "name": "(UTC +02:00) Asia/Damascus"
    },
    {
        "id": "Asia/Famagusta",
        "name": "(UTC +02:00) Asia/Famagusta"
    },
    {
        "id": "Asia/Gaza",
        "name": "(UTC +02:00) Asia/Gaza"
    },
    {
        "id": "Asia/Hebron",
        "name": "(UTC +02:00) Asia/Hebron"
    },
    {
        "id": "Asia/Jerusalem",
        "name": "(UTC +02:00) Asia/Jerusalem"
    },
    {
        "id": "Asia/Nicosia",
        "name": "(UTC +02:00) Asia/Nicosia"
    },
    {
        "id": "Europe/Athens",
        "name": "(UTC +02:00) Europe/Athens"
    },
    {
        "id": "Europe/Bucharest",
        "name": "(UTC +02:00) Europe/Bucharest"
    },
    {
        "id": "Europe/Chisinau",
        "name": "(UTC +02:00) Europe/Chisinau"
    },
    {
        "id": "Europe/Helsinki",
        "name": "(UTC +02:00) Europe/Helsinki"
    },
    {
        "id": "Europe/Kaliningrad",
        "name": "(UTC +02:00) Europe/Kaliningrad"
    },
    {
        "id": "Europe/Kiev",
        "name": "(UTC +02:00) Europe/Kiev"
    },
    {
        "id": "Europe/Mariehamn",
        "name": "(UTC +02:00) Europe/Mariehamn"
    },
    {
        "id": "Europe/Riga",
        "name": "(UTC +02:00) Europe/Riga"
    },
    {
        "id": "Europe/Sofia",
        "name": "(UTC +02:00) Europe/Sofia"
    },
    {
        "id": "Europe/Tallinn",
        "name": "(UTC +02:00) Europe/Tallinn"
    },
    {
        "id": "Europe/Uzhgorod",
        "name": "(UTC +02:00) Europe/Uzhgorod"
    },
    {
        "id": "Europe/Vilnius",
        "name": "(UTC +02:00) Europe/Vilnius"
    },
    {
        "id": "Europe/Zaporozhye",
        "name": "(UTC +02:00) Europe/Zaporozhye"
    },
    {
        "id": "Africa/Addis_Ababa",
        "name": "(UTC +03:00) Africa/Addis_Ababa"
    },
    {
        "id": "Africa/Asmara",
        "name": "(UTC +03:00) Africa/Asmara"
    },
    {
        "id": "Africa/Dar_es_Salaam",
        "name": "(UTC +03:00) Africa/Dar_es_Salaam"
    },
    {
        "id": "Africa/Djibouti",
        "name": "(UTC +03:00) Africa/Djibouti"
    },
    {
        "id": "Africa/Kampala",
        "name": "(UTC +03:00) Africa/Kampala"
    },
    {
        "id": "Africa/Mogadishu",
        "name": "(UTC +03:00) Africa/Mogadishu"
    },
    {
        "id": "Africa/Nairobi",
        "name": "(UTC +03:00) Africa/Nairobi"
    },
    {
        "id": "Antarctica/Syowa",
        "name": "(UTC +03:00) Antarctica/Syowa"
    },
    {
        "id": "Asia/Aden",
        "name": "(UTC +03:00) Asia/Aden"
    },
    {
        "id": "Asia/Baghdad",
        "name": "(UTC +03:00) Asia/Baghdad"
    },
    {
        "id": "Asia/Bahrain",
        "name": "(UTC +03:00) Asia/Bahrain"
    },
    {
        "id": "Asia/Kuwait",
        "name": "(UTC +03:00) Asia/Kuwait"
    },
    {
        "id": "Asia/Qatar",
        "name": "(UTC +03:00) Asia/Qatar"
    },
    {
        "id": "Asia/Riyadh",
        "name": "(UTC +03:00) Asia/Riyadh"
    },
    {
        "id": "Europe/Istanbul",
        "name": "(UTC +03:00) Europe/Istanbul"
    },
    {
        "id": "Europe/Kirov",
        "name": "(UTC +03:00) Europe/Kirov"
    },
    {
        "id": "Europe/Minsk",
        "name": "(UTC +03:00) Europe/Minsk"
    },
    {
        "id": "Europe/Moscow",
        "name": "(UTC +03:00) Europe/Moscow"
    },
    {
        "id": "Europe/Simferopol",
        "name": "(UTC +03:00) Europe/Simferopol"
    },
    {
        "id": "Europe/Volgograd",
        "name": "(UTC +03:00) Europe/Volgograd"
    },
    {
        "id": "Indian/Antananarivo",
        "name": "(UTC +03:00) Indian/Antananarivo"
    },
    {
        "id": "Indian/Comoro",
        "name": "(UTC +03:00) Indian/Comoro"
    },
    {
        "id": "Indian/Mayotte",
        "name": "(UTC +03:00) Indian/Mayotte"
    },
    {
        "id": "Asia/Tehran",
        "name": "(UTC +03:30) Asia/Tehran"
    },
    {
        "id": "Asia/Baku",
        "name": "(UTC +04:00) Asia/Baku"
    },
    {
        "id": "Asia/Dubai",
        "name": "(UTC +04:00) Asia/Dubai"
    },
    {
        "id": "Asia/Muscat",
        "name": "(UTC +04:00) Asia/Muscat"
    },
    {
        "id": "Asia/Tbilisi",
        "name": "(UTC +04:00) Asia/Tbilisi"
    },
    {
        "id": "Asia/Yerevan",
        "name": "(UTC +04:00) Asia/Yerevan"
    },
    {
        "id": "Europe/Astrakhan",
        "name": "(UTC +04:00) Europe/Astrakhan"
    },
    {
        "id": "Europe/Samara",
        "name": "(UTC +04:00) Europe/Samara"
    },
    {
        "id": "Europe/Saratov",
        "name": "(UTC +04:00) Europe/Saratov"
    },
    {
        "id": "Europe/Ulyanovsk",
        "name": "(UTC +04:00) Europe/Ulyanovsk"
    },
    {
        "id": "Indian/Mahe",
        "name": "(UTC +04:00) Indian/Mahe"
    },
    {
        "id": "Indian/Mauritius",
        "name": "(UTC +04:00) Indian/Mauritius"
    },
    {
        "id": "Indian/Reunion",
        "name": "(UTC +04:00) Indian/Reunion"
    },
    {
        "id": "Asia/Kabul",
        "name": "(UTC +04:30) Asia/Kabul"
    },
    {
        "id": "Antarctica/Mawson",
        "name": "(UTC +05:00) Antarctica/Mawson"
    },
    {
        "id": "Asia/Aqtau",
        "name": "(UTC +05:00) Asia/Aqtau"
    },
    {
        "id": "Asia/Aqtobe",
        "name": "(UTC +05:00) Asia/Aqtobe"
    },
    {
        "id": "Asia/Ashgabat",
        "name": "(UTC +05:00) Asia/Ashgabat"
    },
    {
        "id": "Asia/Atyrau",
        "name": "(UTC +05:00) Asia/Atyrau"
    },
    {
        "id": "Asia/Dushanbe",
        "name": "(UTC +05:00) Asia/Dushanbe"
    },
    {
        "id": "Asia/Karachi",
        "name": "(UTC +05:00) Asia/Karachi"
    },
    {
        "id": "Asia/Oral",
        "name": "(UTC +05:00) Asia/Oral"
    },
    {
        "id": "Asia/Qyzylorda",
        "name": "(UTC +05:00) Asia/Qyzylorda"
    },
    {
        "id": "Asia/Samarkand",
        "name": "(UTC +05:00) Asia/Samarkand"
    },
    {
        "id": "Asia/Tashkent",
        "name": "(UTC +05:00) Asia/Tashkent"
    },
    {
        "id": "Asia/Yekaterinburg",
        "name": "(UTC +05:00) Asia/Yekaterinburg"
    },
    {
        "id": "Indian/Kerguelen",
        "name": "(UTC +05:00) Indian/Kerguelen"
    },
    {
        "id": "Indian/Maldives",
        "name": "(UTC +05:00) Indian/Maldives"
    },
    {
        "id": "Asia/Colombo",
        "name": "(UTC +05:30) Asia/Colombo"
    },
    {
        "id": "Asia/Kolkata",
        "name": "(UTC +05:30) Asia/Kolkata"
    },
    {
        "id": "Asia/Kathmandu",
        "name": "(UTC +05:45) Asia/Kathmandu"
    },
    {
        "id": "Antarctica/Vostok",
        "name": "(UTC +06:00) Antarctica/Vostok"
    },
    {
        "id": "Asia/Almaty",
        "name": "(UTC +06:00) Asia/Almaty"
    },
    {
        "id": "Asia/Bishkek",
        "name": "(UTC +06:00) Asia/Bishkek"
    },
    {
        "id": "Asia/Dhaka",
        "name": "(UTC +06:00) Asia/Dhaka"
    },
    {
        "id": "Asia/Omsk",
        "name": "(UTC +06:00) Asia/Omsk"
    },
    {
        "id": "Asia/Qostanay",
        "name": "(UTC +06:00) Asia/Qostanay"
    },
    {
        "id": "Asia/Thimphu",
        "name": "(UTC +06:00) Asia/Thimphu"
    },
    {
        "id": "Asia/Urumqi",
        "name": "(UTC +06:00) Asia/Urumqi"
    },
    {
        "id": "Indian/Chagos",
        "name": "(UTC +06:00) Indian/Chagos"
    },
    {
        "id": "Asia/Yangon",
        "name": "(UTC +06:30) Asia/Yangon"
    },
    {
        "id": "Indian/Cocos",
        "name": "(UTC +06:30) Indian/Cocos"
    },
    {
        "id": "Antarctica/Davis",
        "name": "(UTC +07:00) Antarctica/Davis"
    },
    {
        "id": "Asia/Bangkok",
        "name": "(UTC +07:00) Asia/Bangkok"
    },
    {
        "id": "Asia/Barnaul",
        "name": "(UTC +07:00) Asia/Barnaul"
    },
    {
        "id": "Asia/Ho_Chi_Minh",
        "name": "(UTC +07:00) Asia/Ho_Chi_Minh"
    },
    {
        "id": "Asia/Hovd",
        "name": "(UTC +07:00) Asia/Hovd"
    },
    {
        "id": "Asia/Jakarta",
        "name": "(UTC +07:00) Asia/Jakarta"
    },
    {
        "id": "Asia/Krasnoyarsk",
        "name": "(UTC +07:00) Asia/Krasnoyarsk"
    },
    {
        "id": "Asia/Novokuznetsk",
        "name": "(UTC +07:00) Asia/Novokuznetsk"
    },
    {
        "id": "Asia/Novosibirsk",
        "name": "(UTC +07:00) Asia/Novosibirsk"
    },
    {
        "id": "Asia/Phnom_Penh",
        "name": "(UTC +07:00) Asia/Phnom_Penh"
    },
    {
        "id": "Asia/Pontianak",
        "name": "(UTC +07:00) Asia/Pontianak"
    },
    {
        "id": "Asia/Tomsk",
        "name": "(UTC +07:00) Asia/Tomsk"
    },
    {
        "id": "Asia/Vientiane",
        "name": "(UTC +07:00) Asia/Vientiane"
    },
    {
        "id": "Indian/Christmas",
        "name": "(UTC +07:00) Indian/Christmas"
    },
    {
        "id": "Asia/Brunei",
        "name": "(UTC +08:00) Asia/Brunei"
    },
    {
        "id": "Asia/Choibalsan",
        "name": "(UTC +08:00) Asia/Choibalsan"
    },
    {
        "id": "Asia/Hong_Kong",
        "name": "(UTC +08:00) Asia/Hong_Kong"
    },
    {
        "id": "Asia/Irkutsk",
        "name": "(UTC +08:00) Asia/Irkutsk"
    },
    {
        "id": "Asia/Kuala_Lumpur",
        "name": "(UTC +08:00) Asia/Kuala_Lumpur"
    },
    {
        "id": "Asia/Kuching",
        "name": "(UTC +08:00) Asia/Kuching"
    },
    {
        "id": "Asia/Macau",
        "name": "(UTC +08:00) Asia/Macau"
    },
    {
        "id": "Asia/Makassar",
        "name": "(UTC +08:00) Asia/Makassar"
    },
    {
        "id": "Asia/Manila",
        "name": "(UTC +08:00) Asia/Manila"
    },
    {
        "id": "Asia/Shanghai",
        "name": "(UTC +08:00) Asia/Shanghai"
    },
    {
        "id": "Asia/Singapore",
        "name": "(UTC +08:00) Asia/Singapore"
    },
    {
        "id": "Asia/Taipei",
        "name": "(UTC +08:00) Asia/Taipei"
    },
    {
        "id": "Asia/Ulaanbaatar",
        "name": "(UTC +08:00) Asia/Ulaanbaatar"
    },
    {
        "id": "Australia/Perth",
        "name": "(UTC +08:00) Australia/Perth"
    },
    {
        "id": "Australia/Eucla",
        "name": "(UTC +08:45) Australia/Eucla"
    },
    {
        "id": "Asia/Chita",
        "name": "(UTC +09:00) Asia/Chita"
    },
    {
        "id": "Asia/Dili",
        "name": "(UTC +09:00) Asia/Dili"
    },
    {
        "id": "Asia/Jayapura",
        "name": "(UTC +09:00) Asia/Jayapura"
    },
    {
        "id": "Asia/Khandyga",
        "name": "(UTC +09:00) Asia/Khandyga"
    },
    {
        "id": "Asia/Pyongyang",
        "name": "(UTC +09:00) Asia/Pyongyang"
    },
    {
        "id": "Asia/Seoul",
        "name": "(UTC +09:00) Asia/Seoul"
    },
    {
        "id": "Asia/Tokyo",
        "name": "(UTC +09:00) Asia/Tokyo"
    },
    {
        "id": "Asia/Yakutsk",
        "name": "(UTC +09:00) Asia/Yakutsk"
    },
    {
        "id": "Pacific/Palau",
        "name": "(UTC +09:00) Pacific/Palau"
    },
    {
        "id": "Australia/Darwin",
        "name": "(UTC +09:30) Australia/Darwin"
    },
    {
        "id": "Antarctica/DumontDUrville",
        "name": "(UTC +10:00) Antarctica/DumontDUrville"
    },
    {
        "id": "Asia/Ust-Nera",
        "name": "(UTC +10:00) Asia/Ust-Nera"
    },
    {
        "id": "Asia/Vladivostok",
        "name": "(UTC +10:00) Asia/Vladivostok"
    },
    {
        "id": "Australia/Brisbane",
        "name": "(UTC +10:00) Australia/Brisbane"
    },
    {
        "id": "Australia/Lindeman",
        "name": "(UTC +10:00) Australia/Lindeman"
    },
    {
        "id": "Pacific/Chuuk",
        "name": "(UTC +10:00) Pacific/Chuuk"
    },
    {
        "id": "Pacific/Guam",
        "name": "(UTC +10:00) Pacific/Guam"
    },
    {
        "id": "Pacific/Port_Moresby",
        "name": "(UTC +10:00) Pacific/Port_Moresby"
    },
    {
        "id": "Pacific/Saipan",
        "name": "(UTC +10:00) Pacific/Saipan"
    },
    {
        "id": "Australia/Adelaide",
        "name": "(UTC +10:30) Australia/Adelaide"
    },
    {
        "id": "Australia/Broken_Hill",
        "name": "(UTC +10:30) Australia/Broken_Hill"
    },
    {
        "id": "Antarctica/Casey",
        "name": "(UTC +11:00) Antarctica/Casey"
    },
    {
        "id": "Antarctica/Macquarie",
        "name": "(UTC +11:00) Antarctica/Macquarie"
    },
    {
        "id": "Asia/Magadan",
        "name": "(UTC +11:00) Asia/Magadan"
    },
    {
        "id": "Asia/Sakhalin",
        "name": "(UTC +11:00) Asia/Sakhalin"
    },
    {
        "id": "Asia/Srednekolymsk",
        "name": "(UTC +11:00) Asia/Srednekolymsk"
    },
    {
        "id": "Australia/Hobart",
        "name": "(UTC +11:00) Australia/Hobart"
    },
    {
        "id": "Australia/Lord_Howe",
        "name": "(UTC +11:00) Australia/Lord_Howe"
    },
    {
        "id": "Australia/Melbourne",
        "name": "(UTC +11:00) Australia/Melbourne"
    },
    {
        "id": "Australia/Sydney",
        "name": "(UTC +11:00) Australia/Sydney"
    },
    {
        "id": "Pacific/Bougainville",
        "name": "(UTC +11:00) Pacific/Bougainville"
    },
    {
        "id": "Pacific/Efate",
        "name": "(UTC +11:00) Pacific/Efate"
    },
    {
        "id": "Pacific/Guadalcanal",
        "name": "(UTC +11:00) Pacific/Guadalcanal"
    },
    {
        "id": "Pacific/Kosrae",
        "name": "(UTC +11:00) Pacific/Kosrae"
    },
    {
        "id": "Pacific/Noumea",
        "name": "(UTC +11:00) Pacific/Noumea"
    },
    {
        "id": "Pacific/Pohnpei",
        "name": "(UTC +11:00) Pacific/Pohnpei"
    },
    {
        "id": "Asia/Anadyr",
        "name": "(UTC +12:00) Asia/Anadyr"
    },
    {
        "id": "Asia/Kamchatka",
        "name": "(UTC +12:00) Asia/Kamchatka"
    },
    {
        "id": "Pacific/Fiji",
        "name": "(UTC +12:00) Pacific/Fiji"
    },
    {
        "id": "Pacific/Funafuti",
        "name": "(UTC +12:00) Pacific/Funafuti"
    },
    {
        "id": "Pacific/Kwajalein",
        "name": "(UTC +12:00) Pacific/Kwajalein"
    },
    {
        "id": "Pacific/Majuro",
        "name": "(UTC +12:00) Pacific/Majuro"
    },
    {
        "id": "Pacific/Nauru",
        "name": "(UTC +12:00) Pacific/Nauru"
    },
    {
        "id": "Pacific/Norfolk",
        "name": "(UTC +12:00) Pacific/Norfolk"
    },
    {
        "id": "Pacific/Tarawa",
        "name": "(UTC +12:00) Pacific/Tarawa"
    },
    {
        "id": "Pacific/Wake",
        "name": "(UTC +12:00) Pacific/Wake"
    },
    {
        "id": "Pacific/Wallis",
        "name": "(UTC +12:00) Pacific/Wallis"
    },
    {
        "id": "Antarctica/McMurdo",
        "name": "(UTC +13:00) Antarctica/McMurdo"
    },
    {
        "id": "Pacific/Apia",
        "name": "(UTC +13:00) Pacific/Apia"
    },
    {
        "id": "Pacific/Auckland",
        "name": "(UTC +13:00) Pacific/Auckland"
    },
    {
        "id": "Pacific/Fakaofo",
        "name": "(UTC +13:00) Pacific/Fakaofo"
    },
    {
        "id": "Pacific/Kanton",
        "name": "(UTC +13:00) Pacific/Kanton"
    },
    {
        "id": "Pacific/Tongatapu",
        "name": "(UTC +13:00) Pacific/Tongatapu"
    },
    {
        "id": "Pacific/Chatham",
        "name": "(UTC +13:45) Pacific/Chatham"
    },
    {
        "id": "Pacific/Kiritimati",
        "name": "(UTC +14:00) Pacific/Kiritimati"
    }
];

export default timezones;